import { render, staticRenderFns } from "./shopApply.vue?vue&type=template&id=a289b132&"
import script from "./shopApply.vue?vue&type=script&lang=js&"
export * from "./shopApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports